const MyTitle = (props) => {
  const { title = "", ...rest } = props;

  return (
    <div className={`flex items-center gap-3 ${rest?.className || ""}`}>
      <img
        src="/assets/img/point.png"
        alt=""
        className="w-full h-auto max-w-8"
      />
      <h3 className="font-semibold sm:text-xl">{title}</h3>
    </div>
  );
};

export default MyTitle;
